import { Component, OnDestroy, OnInit } from '@angular/core';
import { TaleplerPage } from '../model/talepler-page';
import { HelperProvider } from '../providers/helper.provider';
import { RestService } from '../providers/rest.service';
import { Page } from '../model/page';
import { Talep } from '../model/talep';
import { Pair } from '../model/pair';
import { Teklif } from '../model/teklif';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-teklifler',
  templateUrl: './teklifler.component.html',
  styleUrls: ['./teklifler.component.css']
})
export class TekliflerComponent implements OnInit, OnDestroy {
  DURUM_INITIAL = Teklif.DURUM_INITIAL;
  DURUM_CEVAPLANDI = Teklif.DURUM_CEVAPLANDI;
  DURUM_RED = Teklif.DURUM_RED;
  DURUM_IPTAL = Teklif.DURUM_IPTAL;
  DURUM_REVIZE_EDILDI = Teklif.DURUM_REVIZE_EDILDI;
  DURUM_DEGERLENDIRILDI = Teklif.DURUM_DEGERLENDIRILDI;

  // DURUM_SIPARIS_OLUSTURULDU = Talep.DURUM_SIPARIS_OLUSTURULDU;

  showSearchResultCountTalep = 10;
  showSearchResultCountTeklif = 10;
  showSearchResultCountTeklif2 = 10;
  showSearchResultCountModelTalep: number[] = [10, 20, 50, 100];
  showSearchResultCountModelTeklif: number[] = [10, 20, 50, 100];
  showSearchResultCountModelTeklif2: number[] = [10, 20, 50, 100];
  talepAraLoading = false;
  talepAraText = '';
  teklifAraLoading = false;
  teklifAraLoading2 = false;
  teklifAraText = '';
  teklifAraText2 = '';
  sourceTalep: TaleplerPage = null;
  showSearchCurrentPageTalep = 1;
  showSearchCurrentPageTeklif = 1;
  showSearchCurrentPageTeklif2 = 1;
  durumText = 'Teklif Toplanıyor';
  // sourceTeklif: TekliflerPage = null;
  sourceTeklif: TaleplerPage = null;
  sourceTeklif2: Talep[] = null;
  isTeklifSiparis: boolean;
  filterStatus: Pair[] = [];
  orderByTeklifler:boolean = false;
  // filterStatus2: Pair[] = [];
  private subscriptions: Subscription[] = [];

  constructor(private helperProvider: HelperProvider,
    private restService: RestService) {
  }

  ngOnInit(): void {
    this.filterStatus.push(new Pair(this.DURUM_INITIAL, true));
    this.filterStatus.push(new Pair(this.DURUM_CEVAPLANDI, true));
    this.filterStatus.push(new Pair(this.DURUM_RED, true));
    this.filterStatus.push(new Pair(this.DURUM_IPTAL, true));
    this.filterStatus.push(new Pair(this.DURUM_REVIZE_EDILDI, true));
    this.filterStatus.push(new Pair(this.DURUM_DEGERLENDIRILDI, true));
    
    // this.filterStatus2.push(new Pair(this.DURUM_SIPARIS_OLUSTURULDU, false));

    this.helperProvider.currentPage$.next(Page.Teklifler);
    this.getTalepler();
    this.getTeklifler();
    this.getSiparisVerilecekler();
    this.subscriptions.push(this.helperProvider.changedSelectedBranches$.subscribe(res => {
      if (res != null) {
        this.getTalepler();
        this.getTeklifler();
        this.getSiparisVerilecekler();
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getTalepler() {
    const durum: number[] = [Talep.DURUM_TEKLIF_TOPLA];
    this.restService.talepler(this.showSearchCurrentPageTalep, this.showSearchResultCountTalep, durum, this.talepAraText, false, 1, 1).subscribe(res => {
      this.sourceTalep = res;
    });
  }

  orderTeklifler() {
    this.orderByTeklifler = !this.orderByTeklifler;
    this.getTeklifler();
  }

  getTeklifler() {
    const durum = this.filterStatus.filter(x => x.value).map(x => x.key);
    // this.restService.teklifler(this.showSearchCurrentPageTeklif, this.showSearchResultCountTeklif, durum, this.teklifAraText).subscribe(res => {
    //   this.sourceTeklif = res;
    // });
    this.restService.talepler(this.showSearchCurrentPageTeklif, this.showSearchResultCountTeklif, durum, this.teklifAraText, false, 1, 2,this.orderByTeklifler).subscribe(res => {
      this.sourceTeklif = res;
      this.sourceTeklif.isTeklif = true;
    });
  }


  getSiparisVerilecekler() {
    // const durum = this.filterStatus.filter(x => x.value).map(x => x.key);
    // const durum = this.filterStatus2.filter(x => x.value).map(x => x.key);
    // const durum: number[] = [Talep.DURUM_SIPARIS_OLUSTURULDU];
    // this.restService.teklifler(this.showSearchCurrentPageTeklif, this.showSearchResultCountTeklif, durum, this.teklifAraText).subscribe(res => {
    //   this.sourceTeklif = res;
    // });
    // this.restService.getSiparisVerilecekler(this.showSearchCurrentPageTeklif2, this.showSearchResultCountTeklif2, durum, this.teklifAraText2, false, 1, 2).subscribe(res => {
      // this.sourceTeklif2 = res;
      // this.isTeklifSiparis = true;
    // });
  }

  

  iptalEt(t: Talep) {

  }

  showPreviousPageSearchResultsTalep() {
    this.showSearchCurrentPageTalep--;
    this.getTalepler();
  }

  showNextPageSearchResultsTalep() {
    this.showSearchCurrentPageTalep++;
    this.getTalepler();
  }

  talepAraInputChange() {
    this.showSearchCurrentPageTalep = 1;
    this.getTalepler();
  }

  // new() {
  //   this.router.navigate(['talep'], { queryParams: { id: '0' } });
  // }


  showPreviousPageSearchResultsTeklif() {
    this.showSearchCurrentPageTeklif--;
    this.getTeklifler();
  }

  showNextPageSearchResultsTeklif() {
    this.showSearchCurrentPageTeklif++;
    this.getTeklifler();
  }

  teklifAraInputChange() {
    this.showSearchCurrentPageTeklif = 1;
    this.getTeklifler();
  }

  showPreviousPageSearchResultsTeklif2() {
    this.showSearchCurrentPageTeklif2--;
    this.getSiparisVerilecekler();
  }

  showNextPageSearchResultsTeklif2() {
    this.showSearchCurrentPageTeklif2++;
    this.getSiparisVerilecekler();
  }

  teklifAraInputChange2() {
    this.showSearchCurrentPageTeklif2 = 1;
    this.getSiparisVerilecekler();
  }

  filter(selected: string) {
    for (const f of this.filterStatus) {
      if (f.key === selected) {
        f.value = !f.value;
      }
    }
    this.getTeklifler();
  }

  // getDurumText(key: any) {
  //   return Teklif.getDurumText(key, false);
  // }

}

